<template>
  <div class="madia-nav">
    <el-button @click="mediaNavShow" class="text">
      <i class="iconfont icon-ego-menu"></i>
    </el-button>
    <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      v-show="isShow"
      unique-opened
    >
      <template v-for="item in menuData">
        <el-menu-item
          :index="item.index"
          :key="item.index"
          v-if="item.child.length === 0"
        >
          <!-- <i class="iconfont icon-xuanzhongshangcheng"></i> -->
          <span slot="title">
            <router-link :to="item.to">{{ item.label }}</router-link>
          </span>
        </el-menu-item>
        <el-submenu
          :index="item.index"
          :key="item.index"
          :show-timeout="100"
          v-else
        >
          <template slot="title">
            <!-- <i class="iconfont icon-3Ddayin"></i> -->
            <span>{{ item.label }}</span>
          </template>

          <template v-for="child in item.child">
            <el-menu-item
              :index="child.index"
              :key="child.index"
              v-if="child.child.length === 0"
            >
              <a :href="child.to" target="_blank">{{ child.label }}</a>
            </el-menu-item>
            <el-submenu
              :index="child.index"
              :key="child.index"
              :show-timeout="100"
              v-else
            >
              <template slot="title">{{ child.label }}</template>
              <!--third-->
              <el-menu-item
                v-for="grandson in child.child"
                :index="grandson.index"
                :key="grandson.index"
                ><router-link tag="a" :to="grandson.to">
                  {{ grandson.label }}
                </router-link>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //   isCollapse: true,
      isShow: false,
      menuData: [],
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    mediaNavShow() {
      this.isShow = true;
    },

    async init() {
      this.menuData.push({
        label: this.$lang.com("home"),
        index: "0",
        to: "/",
        child: [],
      });
      // 后台分类
      let map = {
        machine: {
          path: "/machine",
        },
        product: {
          path: "/product",
        },
        model: {
          path: "/model",
        },
        about: {
          path: "/about",
        },
        community: {
          path: "",
        },
        config: {
          path: "",
        },
      };
      for (var item of this.$store.state.data.categories) {
        for (var key in map) {
          if (item.category_keywords === key) {
            let cur;
            // 主板放在product前面
            if (key === "product") {
              this.menuData.push({
                label: this.$lang.com("Board"),
                index: "10",
                to: "",
                child: [
                  {
                    label: this.$lang.com("Tutorial"),
                    index: "10-1",
                    to: "/document/Lerdge-Board",
                    child: [],
                  },
                  {
                    label: "Gcode",
                    index: "10-2",
                    to: "/document/detail/G0-G1",
                    child: [],
                  },
                  {
                    label: this.$lang.com("homeDownLoad"),
                    index: "10-3",
                    to: "/download/list/lerdge-k",
                    child: [],
                  },
                ],
              });
            }
            if (key === "product" && this.$lang.current === "en") {
              cur = {
                label: "Store",
                index: item.category_id.toString(),
                to: `https://shop.lerdge.com/`,
                child: [],
                isOutside: true,
              };
            } else if (key === "product" && this.$lang.current === "cn") {
              cur = {
                label: "商店",
                index: item.category_id.toString(),
                child: [
                  {
                    label: "淘宝",
                    index: "-1",
                    to: `https://lerdge.taobao.com/index.htm?spm=a1z10.3-c-s.w5002-23038214275.2.46d7c451eYuQFk`,
                    child: [],
                    isOutside: true,
                  },
                  {
                    label: "商城",
                    index: "-2",
                    to: `https://shop.lerdge.com/`,
                    child: [],
                    isOutside: true,
                  },
                ],
              };
            } else {
              let path = map[key].path;
              cur = {
                label: item.category_name,
                index: item.category_id.toString(),
                keywords: item.category_keywords,
                to: `${path === "" ? "" : path}/${item.category_keywords}`,
                child: [],
              };
              if (item.child.length > 0) {
                for (var child of item.child) {
                  cur.child.push({
                    label: child.category_name,
                    index: child.category_id.toString(),
                    keywords: child.category_keywords,
                    to: `${path}/${child.category_keywords}`,
                    child: [],
                  });
                }
              }
            }
            if (key === "community") {
              cur = {
                label: this.$lang.com("community"),
                index: "-1",
                to: "/community",
                child: [],
              };
            }
            this.menuData.push(cur);
            break;
          }
        }
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.el-menu {
  position: absolute;
  border-radius: 4px;
  top: 58px;
  right: 10px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
  min-height: 400px;
}
</style>
